export default class DiscountCode {
  data = null;

  constructor(data) {
    this.data = data;
  }
}
